<section class="{{ classes }} main-section">
  <div class="container-fluid main-container" [ngClass]="{'mobile-image-background': mobileImageBackground}"
       [style.background-image]="imageSafeStyleUrl"
       [style.background-size]="'cover'"
       [style.background-repeat]="'no-repeat'"
       [style.background-position]="'center center'">

    <div class="row h-100">
      <!-- router link enabled -->
      <div (click)="gotoRoute(!!contentLink && contentLink != '' ? contentLink : null, $event)"
           class="content-section content-padding col-md-6 col-lg-5 col-xl-4"
           [ngClass]="{ 'order-md-last': contentLeft === false }">
        <section class="h-100">
          <div class="container h-100">
            <ng-content></ng-content>
          </div>
        </section>
      </div>
      <div class="col-md-6 col-lg-7 col-xl-8 p-0 d-md-block" [ngClass]="{'center-video-background': (!!videoUrl || !!embedUrl) && fixedAspectRatio && center}">
        <div [ngClass]="{'aspect-ratio-box-3-2': !videoUrl && !embedUrl && fixedAspectRatio, 'aspect-ratio-box-16-9': (!!videoUrl || !!embedUrl) && fixedAspectRatio, 'full-height': !fixedAspectRatio}">
          <carousel #carousel [interval]="0" [ngClass]="{'full-height': !fixedAspectRatio}">
            <slide [active]="true" [ngClass]="{'full-height': !fixedAspectRatio}">
              <div *ngIf="!!imageUrl && !videoUrl && !embedUrl" class="background content-padding" [ngClass]="{'aspect-ratio-box-3-2': fixedAspectRatio}"
                   [style.background-image]="imageSafeStyleUrl">
              </div>
              <div *ngIf="!!videoUrl && !embedUrl" [ngClass]="{'aspect-ratio-box-16-9': fixedAspectRatio}">
                <video controls [src]="videoSafeResourceUrl" [poster]="imageSafeResourceUrl">
                  <source [src]="videoSafeResourceUrl"/>
                </video>
              </div>
              <div *ngIf="!!embedUrl" [ngClass]="{'aspect-ratio-box-16-9': fixedAspectRatio, 'full-height': !fixedAspectRatio}">
                <div class="iframe-container">
                  <iframe
                    [src]="embedSafeResourceUrl"
                    allowfullscreen=""
                    data-aspectratio="0.5625"
                    class="h-100 w-100"
                    frameborder="0"
                    [attr.aria-label]="embedLabel"
                    [title]="embedLabel"
                  ></iframe>
                </div>
              </div>
            </slide>

            <slide *ngFor="let media of mediaItems" [ngClass]="{'full-height': !fixedAspectRatio}">
              <div *ngIf="!!media.imageUrl" class="background content-padding" [ngClass]="{'aspect-ratio-box-3-2': fixedAspectRatio}"
                   [style.background-image]="safeStyle(media.imageUrl)">
              </div>

              <div *ngIf="!!media.embedUrl && !!safeResourceUrlCache[media.embedUrl]" [ngClass]="{'aspect-ratio-box-16-9': fixedAspectRatio, 'full-height': !fixedAspectRatio}">
                <div class="iframe-container">
                  '{{ media.embedUrl }}', {{ safeResourceUrlCache[media.embedUrl][autoplayVideo] }}
                  <iframe id="player"
                          [src]="safeResourceUrlCache[media.embedUrl][autoplayVideo]"
                          allowfullscreen=""
                          allow="autoplay; encrypted-media"
                          data-aspectratio="0.5625"
                          class="h-100 w-100"
                          frameborder="0"></iframe>
                </div>
              </div>
            </slide>
          </carousel>
        </div>
      </div>
    </div>
  </div>
</section>
